import { locale } from '@/shared/i18n';

/** Public paths that should receive the /vi prefix when locale is 'vi'. */
const PREFIXABLE_PATHS = [
  '/welcome',
  '/pricing',
  '/privacy',
  '/terms',
  '/billing-terms',
  '/features/',
  '/blogs',
];

function shouldPrefix(path: string): boolean {
  // Strip hash fragment before matching
  const bare = path.split('#')[0] ?? '';
  return PREFIXABLE_PATHS.some((p) => bare === p || bare.startsWith(p));
}

/**
 * Returns a reactive function that prepends /vi to public marketing page paths
 * when the active locale is 'vi'.
 *
 * Links to app pages (/login, /signup, /inventory, etc.) are returned unchanged.
 *
 * Usage inside a component:
 *   const pp = usePublicPath();
 *   <A href={pp('/pricing')}>Pricing</A>
 */
export function usePublicPath(): (path: string) => string {
  return (path: string) => {
    if (locale() !== 'vi') return path;
    if (!shouldPrefix(path)) return path;
    if (path.startsWith('/vi')) return path; // already prefixed
    return `/vi${path}`;
  };
}
